import React from 'react';

interface Props {
	/** Translated string with placeholders, e.g. 'Write to {email} or open {settings}.' */
	text: string;
	/** Node to render for each placeholder, keyed by the placeholder itself. */
	parts: Record<string, React.ReactNode>;
}

const escapeForRegExp = (value: string) =>
	value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * Renders a translated string with inline nodes (usually links) in place of its
 * placeholders, so translators keep one sentence and can move the links around.
 */
export const TextWithLinks: React.FC<Props> = ({ text, parts }) => {
	const placeholders = Object.keys(parts);

	if (!placeholders.length) {
		return <>{text}</>;
	}

	const pattern = new RegExp(
		`(${placeholders.map(escapeForRegExp).join('|')})`,
	);

	return (
		<>
			{text.split(pattern).map((chunk, index) => {
				const part = parts[chunk];

				return part ? (
					<React.Fragment key={`${chunk}-${index}`}>{part}</React.Fragment>
				) : (
					chunk
				);
			})}
		</>
	);
};
